var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kr-help-modal-content" },
    [
      _vm._l(_vm.contentTexts, function (text, idx) {
        return _c("div", { staticClass: "kr-help-content" }, [
          _c("p", { attrs: { id: _vm.uniqUidList[idx] } }, [
            _vm._v(_vm._s(text)),
          ]),
        ])
      }),
      _vm.helpImage
        ? _c(
            "div",
            {
              class: _vm.dynamicClasses.image,
              attrs: { "data-testid": "imageWrapper" },
            },
            [
              _c("SvgImage", {
                attrs: {
                  "aria-label": _vm.label,
                  "aria-describedby": _vm.describerIdList,
                  template: _vm.helpImage,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }